export default __webpack_public_path__ + "static/media/mait.251e8acb.png";